export const REMOVE_ACTIONS = {
  NO_ACTION: 'NO_ACTION',
  RELATION_RECEIPT: 'RELATION_RECEIPT',
  RELATION_RECEIPT_AND_RECEIPT: 'RELATION_RECEIPT_AND_RECEIPT',
};
